import clsx from "clsx";

const gradientDirectionMap = {
  t: "bg-gradient-to-t",
  b: "bg-gradient-to-b",
  l: "bg-gradient-to-l",
  r: "bg-gradient-to-r",
  tr: "bg-gradient-to-tr",
  tl: "bg-gradient-to-tl",
  br: "bg-gradient-to-br",
  bl: "bg-gradient-to-bl",
};

interface GradientOverlayProps {
  direction?: keyof typeof gradientDirectionMap;
  from?: string;
  via?: string;
  to?: string;
  className?: string;
  style?: React.CSSProperties;
}

export const GradientOverlay = ({
  direction,
  from,
  via,
  to,
  className,
  style,
}: GradientOverlayProps) => {
  return (
    <div
      aria-hidden
      className={clsx(
        "absolute inset-0",
        direction ? gradientDirectionMap[direction] : "",
        from,
        via,
        to,
        className,
      )}
      style={style}
    />
  );
};
